module.exports = __webpack_public_path__ + "static/media/Story_3-min.7ebc4021.jpg";